module.exports = __webpack_public_path__ + "static/media/real4.5c8e8efa.jpg";